module.exports = __webpack_public_path__ + "img/hero_desktop.f1473748.png";